module.exports = __webpack_public_path__ + "static/media/11.f5651a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/11.png
// module id = 648
// module chunks = 0